import React, { useState, useEffect } from "react";
import { FaFileAudio, FaStop, FaMicrophone } from "react-icons/fa";
import MicRecorder from 'mic-recorder-to-mp3';
import axios from "axios";
import { RingLoader } from "react-spinners";
import { alert_error, alert_success } from "../AppContext.js";
import { useParams } from "react-router-dom";
import { Cookies } from "../index.js";
import AudioPlayer from "../app_structure/AudioPlayer.jsx";
import Select from "react-select";
import CryptoJS from "crypto-js";
import { isLocalHost } from "../shared/host_utils.js";
const Mp3Recorder = new MicRecorder({ bitRate: 128 });
const Texttovoice = () => {
  const [selectedOption, setSelectedOption] = useState(null); // Khởi tạo state cho giá trị được chọn
  const [src, setsrc] = useState("");
  const [thanhcong, setthanhcong] = useState(false);
  const [startTime, setstartTime] = useState(false);
  const [caption, setcaption] = useState(false);
  const [nutxuly, setnutxuly] = useState(0);
  const [nutorder, setnutorder] = useState(" Chuyển đổi 📝🌐");
  const [isBlocked, setIsBlocked] = useState(false);
  const [dalaythongtin, setdalaythongtin] = useState(false);
  const [thongtincum, setthongtincum] = useState(false);
  const [token, settoken] = useState(false);
  const [thoiluong, setthoiluong] = useState(false);
  const [audioduration, setaudioduration] = useState(false);
  const [loadstart, setloadstart] = useState(true);
  const [dungghi, setdungghi] = useState(false);
  const [money, setmoney] = useState(null);
  const [isOpen, setIsOpen] = useState(true);
  const [type_user, settype_user] = useState('');
  const [typeuser, settypeuser] = useState("individual");
  const [options, setOptions] = useState([
    { label: "Tiếng Anh", value: "en-US" },
    { label: "Tiếng Việt", value: "vi-VN" },
  ]);
  const [social, setSocial] = useState('');
  const [isRecordingok, setIsRecordingok] = useState(false);
  const [blobURL, setBlobURL] = useState('');
  const [blobdata, setblobdata] = useState(null);
  const [type, settype] = useState(null);
  const [text, settext] = useState(null);


  const sendAudioData = (audioBlob) => {
    const formData = new FormData();
    formData.append('file', audioBlob); // blob là biến chứa dữ liệu audioBlob
  };
  const handleRecording = () => {
    console.log(isRecordingok);
    setIsRecordingok(!isRecordingok);
    if (isRecordingok == true) {
      stopRecording();
    }
    else if (isRecordingok == false) {
      startRecording();
    }

  };
  function stopRecording() {
    setdungghi(true);
    setTimeout(() => {
      stopRecordingok();
    }, 1000);
  }
  const startRecording = () => {
    if (isBlocked) {
      alert_error('Mic bị lỗi');
    } else {

      Mp3Recorder.start()
        .then(() => {
          setstartTime(Date.now());
          setIsRecording(true);
          startSendingAudio();
        })
        .catch((e) => console.error(e));
    }

  };
  var CryptoJSAesJson = {
    stringify: function (cipherParams) {
      var j = { ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64) };
      if (cipherParams.iv) j.iv = cipherParams.iv.toString();
      if (cipherParams.salt) j.s = cipherParams.salt.toString();
      return JSON.stringify(j);
    },
    parse: function (jsonStr) {
      var j = JSON.parse(jsonStr);
      var cipherParams = CryptoJS.lib.CipherParams.create({
        ciphertext: CryptoJS.enc.Base64.parse(j.ct),
      });
      if (j.iv) cipherParams.iv = CryptoJS.enc.Hex.parse(j.iv);
      if (j.s) cipherParams.salt = CryptoJS.enc.Hex.parse(j.s);
      return cipherParams;
    },
  };
  const stopRecordingok = () => {
    // socket.disconnect();
    setdungghi(false);
    Mp3Recorder.stop()
      .getMp3()
      .then(([buffer, blob]) => {
        const blobURL = URL.createObjectURL(blob);
        setBlobURL(blobURL);
        setIsRecording(false);
        sendAudioData(blob);
        setblobdata(blob);
        const endTime = Date.now();
        console.log(endTime);
        let thoiluong = (Math.floor((endTime - startTime) / 1000 + 1)); // Tính số giây đã ghi âm

        if (thoiluong) {
          setaudioduration(thoiluong);
          let demtien = Math.round(thoiluong / 3);
          setmoney(demtien);
          const plaintext = thoiluong.toString();
          setthoiluong(plaintext);
          const myCookieValue = Cookies.get('apikey');
          let encryptedText = CryptoJS.AES.encrypt(plaintext, myCookieValue, {
            format: CryptoJSAesJson,
          }).toString();
          console.log(encryptedText);
          encryptedText = encodeURIComponent(encryptedText);
          settoken(encryptedText);
          settype('ghiam');
        }

      })
      .catch((e) => console.log(e));

  };
  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (file) {
      const fileName = file.name;
      setSelectedFile(file);
      setcaption(fileName);
      setIsRecordingok(true);
      console.log(`Tên tệp: ${fileName}`);
      const audio = new Audio();
      const objectURL = URL.createObjectURL(file);
      audio.addEventListener("loadedmetadata", () => {
        let thoiluong = audio.duration;
        thoiluong = Math.round(thoiluong);
        setaudioduration(thoiluong);
        let demtien = Math.round(thoiluong / 3);
        setmoney(demtien);
        const plaintext = thoiluong.toString();
        setthoiluong(plaintext);
        const myCookieValue = Cookies.get('apikey');
        let encryptedText = CryptoJS.AES.encrypt(plaintext, myCookieValue, {
          format: CryptoJSAesJson,
        }).toString();
        console.log(encryptedText);
        encryptedText = encodeURIComponent(encryptedText);
        settoken(encryptedText);
        settype('upfile');
        // console.log('Encrypted text:', encryptedText);;
      });
      audio.src = objectURL;
    }
  };
  const startSendingAudio = () => {

    Mp3Recorder
      .getMp3()
      .then(([buffer, blob]) => {
        // sendAudioData(blob);
      })
      .catch((e) => console.log(e));

  };
  const api = (audioBlob) => {
    const myCookieValue = Cookies.get('apikey');
    // Bây giờ bạn có thể gửi audioBlob qua API bằng Axios
    // Thay thế URL dưới đây bằng URL API thực tế của bạn
    let encryptedText = CryptoJS.AES.encrypt(thoiluong, myCookieValue, {
      format: CryptoJSAesJson,
    }).toString();
    console.log(encryptedText);
    encryptedText = encodeURIComponent(encryptedText);
    const apiUrl = "https://tecom.pro/truyenthanh/tool/voicetotext.php?service=" + social + '&apikey=' + myCookieValue + '&token=' + encryptedText;

    const formData = new FormData();
    formData.append("audio", audioBlob);

    axios
      .post(apiUrl, formData)
      .then((response) => {
        setsrc("https://tecom.pro/truyenthanh/file/" + response.data);
        settenfile(response.data);
        testFunction(response);
        console.log("Phản hồi từ API:", response.data);
        setnutxuly(0);
      })
      .catch((error) => {
        alert_error("Lỗi khi gửi tệp âm thanh:", error);
        setnutxuly(0);
        setnutorder(" Chuyển đổi 📝🌐");
      });
  }
  const handleTextToSpeech = () => {
    setnutxuly(1);
    setthanhcong(false);
    setnutorder('Đợi xíu nhé');
    // Xử lý logic chuyển văn bản thành giọng nói ở đây
    // Sử dụng giá trị trong biến `text`
    if (type) {
      if (type == 'upfile') {
        if (!selectedFile) {
          alert("Hãy chọn một tệp âm thanh trước.");
          return;
        }
        setIsRecordingok(true);
        // Chuyển đổi tệp âm thanh thành Blob
        const reader = new FileReader();
        reader.readAsArrayBuffer(selectedFile);
        reader.onload = () => {
          const audioBlob = new Blob([reader.result], {
            type: selectedFile.type,
          });
          api(audioBlob);
        };
      }
      else if (type == 'ghiam') {
        api(blobdata);
      }

    } else {
      console.log(type);
      setIsRecording(false);
      setsrc("");
      setnutxuly(0);
      setnutorder(" Chuyển đổi 📝🌐");
    }
  };

  useEffect(() => {
    const currentDomain = window.location.hostname;
    console.log(currentDomain);
    const Type_user = Cookies.get('type_user');
    if (isLocalHost(currentDomain) || currentDomain == "hust.media" || Type_user == 'personal' ) {
      settypeuser("personal");
      settype_user(Type_user);
    } else {
    }
  }, []);
  function saochep(value) {
    alert_success('Đã sao chép');
    window.saochepnative(value);

  };
  const handleReset = () => {
    setnutorder(" Chuyển đổi 📝🌐");
    resetok();
  };
  const resetok = () => {
    setthanhcong(false);
    setsrc("");
  };

  const handleFocus = () => {
    setIsOpen(true);
    console.log(123);
  };

  const handleBlur = () => {
    setIsOpen(false);
  };

  const handleMenuOpen = () => {
    setIsOpen(true);
  };

  const handleChange = (selectedOption) => {
    setSelectedOption(selectedOption); // Cập nhật state khi giá trị được chọn thay đổi
    setIsOpen(false);
    setSocial(selectedOption.value);
  };
  const [selectedFile, setSelectedFile] = useState(null);
  const [isRecording, setIsRecording] = useState(false);
  const [tenfile, settenfile] = useState(false);
  function testFunction(response) {
    console.log(response.data);
    const info = response.data;
    const status = info.status;
    const message = info.message;
    const text = info.text;
    if (status == 0) {
      setnutxuly(0);
      alert_error(message);
      setnutorder(" Chuyển đổi 📝🌐");
      setthanhcong(false);
    } else if (status == 1) {
      settoken(false);
      setnutxuly(0);
      alert_success("Thành công");
      setnutorder("Đặt tiếp luôn nào");
      // setsrc(response.data.voice);
      setthanhcong(true);
      settext(text);
    }
  }



  return (
    <>
      {typeuser == "individual" && loadstart ? (
        <div className="flex justify-center items-center">
          <RingLoader size={80} color="#0000ff" />{" "}
        </div>
      ) : dungghi ? (
        <div className="flex justify-center items-center">
          <RingLoader size={80} color="#0000ff" loading={dalaythongtin} />{" "}
        </div>
      ) : !dalaythongtin && !thongtincum && typeuser != "personal" ? (
        <div className="flex justify-center items-center">
          <RingLoader size={80} color="#0000ff" loading={dalaythongtin} />{" "}
        </div>
      ) : (
        <div className="max-w-2xl px-1 py-4   mx-auto rounded-lg shadow-xl ">
          <div className="mx-auto container-fluid mt-0  flex  flex-col  items-center justify-center ">
            <label
              htmlFor="countries2"
              className="text-center text-xs  mb-0  font-medium"
            >
              Chọn Ngôn Ngữ
            </label>
            <Select
              className="w-full max-w-md mb-4"
              classNamePrefix="Chọn 1 lựa chọn"
              value={selectedOption} // Đặt giá trị được chọn cho Select
              onFocus={handleFocus}
              options={options}
              menuIsOpen={isOpen}
              onBlur={handleBlur}
              onMenuOpen={handleMenuOpen}
              onChange={handleChange} // Use selectedOption.value to get the selected value
              isDisabled={false}
              isLoading={false}
              isClearable={true}
              isRtl={false}
              isSearchable={false}
            />

            <div className="flex items-center justify-center ">
              <label
                htmlFor="fileInput"
                className="flex flex-col max-w-md items-center px-4 py-6 bg-white text-blue-700 rounded-lg shadow-lg tracking-wide border border-blue-700 cursor-pointer hover:bg-blue-700 hover:text-pink-500"
              >
                <FaFileAudio className="w-8 h-8" />
                {caption ? (
                  <>
                    {" "}
                    <span className="break-all mt-2 text-base text- whitespace-normal">
                      {caption}
                    </span>
                  </>
                ) : (
                  <>
                    {" "}
                    <span className="mt-2 text-base whitespace-normal">
                      Chọn tệp âm thanh
                    </span>
                  </>
                )}

                <input
                  type="file"
                  id="fileInput"
                  accept=".mp3, .wav, .m4a"
                  className="hidden"
                  onChange={handleFileSelect}
                />
              </label>
            </div>
            <div className="mt-3 mb-3 flex items-center justify-center ">
              <div className="relative inline-block">
                <button
                  className={`bg-green-500 hover:bg-green-600 text-white rounded-full w-28 h-28 flex items-center justify-center focus:outline-none ${isRecording ? 'ring-2 ring-green-600' : ''
                    }`}
                  onClick={handleRecording}
                >
                  {isRecording ? (
                    <FaStop className="text-2xl" />
                  ) : (
                    <FaMicrophone className="text-2xl" />
                  )}
                  {isRecording && (
                    <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center">
                      <div className="absolute w-28 h-28 bg-green-500 opacity-50 rounded-full animate-pulse"></div>
                      <div className="absolute w-32 h-32 bg-green-500 opacity-20 rounded-full animate-pulse"></div>
                      <div className="absolute w-36 h-36 bg-green-500 opacity-10 rounded-full animate-pulse"></div>
                    </div>
                  )}
                </button>
              </div>

            </div>

            {typeuser == "personal" && (
              <>
                <p>
                  🛒 {money} Coins, 🕑 {audioduration} s
                </p>
              </>
            )}
            {blobURL && !isRecordingok && (
              <>
                <audio src={blobURL} className="mt-2" controls="controls" /> </>
            )}
            {/* {thanhcong && (
              <>
                <AudioPlayer src={blobURL} onReset={handleReset} />
              </>
            )} */}
            {thanhcong && (
              <>
                <div className="mt-3 bg-gradient-to-r from-purple-500 via-pink-500 to-red-500 p-2 rounded-lg shadow-lg text-white">
                  <div className="flex flex-row">
                    <div className="  text-sm text-left mt-1 ml-2 text-white">Final:</div>
                    <button onClick={() => saochep(text)} className="ml-auto">
                      <div className="border-1 px-1 rounded-md text-sm ml-auto mt-1 text-white text-sm">Copy</div>
                    </button>
                  </div>
                  <h1 className="text-xl mx-2 font-bold text-white">{text}</h1>
                </div>
              </>
            )}

            <button
              disabled={nutxuly == 1}
              onClick={handleTextToSpeech}
              className="my-3 flex break-inside bg-purple-400 hover:bg-purple-300 rounded-3xl px-8 py-2 mb-0 w-full dark:bg-slate-800 dark:text-white"
            >
              <div className="flex items-center justify-between flex-1">
                {nutxuly == 1 && (
                  <div className="spinner-border" role="status"></div>
                )}

                <span className="text-xl font-medium text-white">
                  {nutorder}{" "}
                </span>

                <div className="text-xl">
                                        {'\u27A4'}
                                    </div>
              </div>
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default Texttovoice;
